import { Button } from 'react-bootstrap'
import { FaBookmark } from 'react-icons/fa'
import { Bookmarkable } from '../../firebase'
import { useAuthState } from '../../firebase/hooks'
import { useBookmark } from '../../hooks/models/useBookmark'
import { Designed } from '../../types'
import { logEvent } from '../../utils'

type Props = {
  bookmarkable: Bookmarkable
}

export const BookmarkButton = ({
  bookmarkable,
  ...otherProps
}: Designed<Props>) => {
  const { user, showSignInPopup } = useAuthState()
  const { bookmark, cancelBookmark, isBookmarked } = useBookmark(bookmarkable)
  return (
    <>
      <Button
        variant="link"
        {...otherProps}
        onClick={async () => {
          if (user === undefined) return
          if (user === null) showSignInPopup()
          if (isBookmarked === undefined) return
          if (isBookmarked) await cancelBookmark()
          else {
            await bookmark()
            logEvent('tap_bookmark_button', { uid: user?.uid })
          }
        }}
      >
        <FaBookmark
          className={isBookmarked === true ? 'text-pink' : 'text-muted'}
        />
      </Button>
    </>
  )
}
